"use strict";
/** @module models */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeatmapParameters = exports.FullJob = exports.JobEvent = exports.JobEventType = exports.StreetView = exports.StreetViewType = exports.JobType = exports.JobTypeEnum = exports.Responder = exports.JobDisposition = exports.Assignment = exports.UnitJob = exports.HAJob = exports.HAResponder = exports.FullSupplemental = exports.SupplementalInfo = void 0;
var cerealParse_1 = require("../cerealParse");
var agency_1 = require("./agency");
var hydrant_1 = require("./hydrant");
var SupplementalInfo = /** @class */ (function () {
    function SupplementalInfo(text, ts) {
        this.text = text;
        this.ts = ts;
    }
    SupplementalInfo.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SupplementalInfo(cerealParse_1.ParseUtils.getString(o, 'txt'), new Date(cerealParse_1.ParseUtils.getNumber(o, 'timeStamp') * 1000)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SupplementalInfo Model: " + e.message);
        }
    };
    return SupplementalInfo;
}());
exports.SupplementalInfo = SupplementalInfo;
var FullSupplemental = /** @class */ (function (_super) {
    __extends(FullSupplemental, _super);
    function FullSupplemental(id, text, ts) {
        var _this = _super.call(this, text, ts) || this;
        _this.id = id;
        _this.text = text;
        _this.ts = ts;
        return _this;
    }
    FullSupplemental.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new FullSupplemental(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'text'), cerealParse_1.ParseUtils.getUNIXTimestampDate(o, 'ts')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid FullSupplemental Model: " + e.message);
        }
    };
    return FullSupplemental;
}(SupplementalInfo));
exports.FullSupplemental = FullSupplemental;
var HAResponder = /** @class */ (function () {
    function HAResponder(id, name, phone) {
        this.id = id;
        this.name = name;
        this.phone = phone;
    }
    HAResponder.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new HAResponder(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getString(o, 'phone')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid HAResponder Model: " + e.message);
        }
    };
    return HAResponder;
}());
exports.HAResponder = HAResponder;
var HAJob = /** @class */ (function () {
    function HAJob(agencyName, description, supplementals, ts) {
        this.agencyName = agencyName;
        this.description = description;
        this.supplementals = supplementals;
        this.ts = ts;
    }
    HAJob.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new HAJob(cerealParse_1.ParseUtils.getString(o, 'departmentName'), cerealParse_1.ParseUtils.getString(o, 'description'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'supp', SupplementalInfo.parse, 'throw'), new Date(cerealParse_1.ParseUtils.getNumber(o, 'timeStamp') * 1000)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid HAJob Model: " + e.message);
        }
    };
    return HAJob;
}());
exports.HAJob = HAJob;
var UnitJob = /** @class */ (function () {
    function UnitJob(id, ts, synopsis, locationOfIncident, typeId) {
        this.id = id;
        this.ts = ts;
        this.synopsis = synopsis;
        this.locationOfIncident = locationOfIncident;
        this.typeId = typeId;
    }
    UnitJob.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new UnitJob(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getUNIXTimestampDate(o, 'ts'), cerealParse_1.ParseUtils.getStringOrNull(o, 'synopsis'), cerealParse_1.ParseUtils.getStringOrNull(o, 'locationOfIncident'), o.type.id));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid UnitJob Model: " + e.message);
        }
    };
    return UnitJob;
}());
exports.UnitJob = UnitJob;
var Assignment = /** @class */ (function () {
    function Assignment(id, ts, name) {
        this.id = id;
        this.ts = ts;
        this.name = name;
    }
    Assignment.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new Assignment(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getUNIXTimestampDate(o, 'ts'), cerealParse_1.ParseUtils.getString(o, 'name')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid Assignment Model: " + e.message);
        }
    };
    return Assignment;
}());
exports.Assignment = Assignment;
var JobDisposition;
(function (JobDisposition) {
    JobDisposition[JobDisposition["open"] = 0] = "open";
    JobDisposition[JobDisposition["closed"] = 1] = "closed";
    JobDisposition[JobDisposition["timedOut"] = 2] = "timedOut";
    JobDisposition[JobDisposition["old"] = 3] = "old";
})(JobDisposition = exports.JobDisposition || (exports.JobDisposition = {}));
var Responder = /** @class */ (function () {
    function Responder(id, verboseResponse, responseTime, yes, name) {
        this.id = id;
        this.verboseResponse = verboseResponse;
        this.responseTime = responseTime;
        this.yes = yes;
        this.name = name;
    }
    Responder.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new Responder(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'verboseResponse'), cerealParse_1.ParseUtils.getUNIXTimestampDate(o, 'responseTime'), cerealParse_1.ParseUtils.getBoolean(o, 'yes'), cerealParse_1.ParseUtils.getString(o, 'name')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid Responder Model: " + e.message);
        }
    };
    return Responder;
}());
exports.Responder = Responder;
var JobTypeEnum;
(function (JobTypeEnum) {
    JobTypeEnum[JobTypeEnum["info"] = 0] = "info";
    JobTypeEnum[JobTypeEnum["fire"] = 1] = "fire";
    JobTypeEnum[JobTypeEnum["ems"] = 2] = "ems";
    JobTypeEnum[JobTypeEnum["police"] = 3] = "police";
    JobTypeEnum[JobTypeEnum["water"] = 4] = "water";
    JobTypeEnum[JobTypeEnum["test"] = 5] = "test";
})(JobTypeEnum = exports.JobTypeEnum || (exports.JobTypeEnum = {}));
var JobType = /** @class */ (function () {
    function JobType(id, type, section, description) {
        this.id = id;
        this.type = type;
        this.section = section;
        this.description = description;
    }
    JobType.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new JobType(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getEnum(o, 'type', JobTypeEnum), cerealParse_1.ParseUtils.getString(o, 'section'), cerealParse_1.ParseUtils.getString(o, 'description')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid JobType Model: " + e.message);
        }
    };
    return JobType;
}());
exports.JobType = JobType;
var StreetViewType;
(function (StreetViewType) {
    StreetViewType[StreetViewType["none"] = 0] = "none";
    StreetViewType[StreetViewType["image"] = 1] = "image";
})(StreetViewType = exports.StreetViewType || (exports.StreetViewType = {}));
var StreetView = /** @class */ (function () {
    function StreetView(type, imageId) {
        this.type = type;
        this.imageId = imageId;
    }
    StreetView.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new StreetView(cerealParse_1.ParseUtils.getEnum(o, 'type', StreetViewType), cerealParse_1.ParseUtils.getStringOrNull(o, 'imageId')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid StreetView Model: " + e.message);
        }
    };
    return StreetView;
}());
exports.StreetView = StreetView;
var JobEventType;
(function (JobEventType) {
    JobEventType[JobEventType["system"] = 0] = "system";
    JobEventType[JobEventType["cad"] = 1] = "cad";
    JobEventType[JobEventType["client"] = 2] = "client";
    JobEventType[JobEventType["custom"] = 3] = "custom";
})(JobEventType = exports.JobEventType || (exports.JobEventType = {}));
var JobEvent = /** @class */ (function () {
    function JobEvent(id, ts, type, key) {
        this.id = id;
        this.ts = ts;
        this.type = type;
        this.key = key;
    }
    JobEvent.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new JobEvent(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getUNIXTimestampDate(o, 'ts'), cerealParse_1.ParseUtils.getEnum(o, 'type', JobEventType), cerealParse_1.ParseUtils.getString(o, 'key')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid JobEvent Model: " + e.message);
        }
    };
    return JobEvent;
}());
exports.JobEvent = JobEvent;
var FullJob = /** @class */ (function () {
    function FullJob(id, agency, assignments, cadId, centroid, crossStreets, delayInSeconds, disposition, hydrants, incidentId, location, locationInfo, locationOfIncident, rawIds, responders, supp, synopsis, ts, type, units, streetView, metaCreationTs, siteSurveys, events, criticalWarning) {
        this.id = id;
        this.agency = agency;
        this.assignments = assignments;
        this.cadId = cadId;
        this.centroid = centroid;
        this.crossStreets = crossStreets;
        this.delayInSeconds = delayInSeconds;
        this.disposition = disposition;
        this.hydrants = hydrants;
        this.incidentId = incidentId;
        this.location = location;
        this.locationInfo = locationInfo;
        this.locationOfIncident = locationOfIncident;
        this.rawIds = rawIds;
        this.responders = responders;
        this.supp = supp;
        this.synopsis = synopsis;
        this.ts = ts;
        this.type = type;
        this.units = units;
        this.streetView = streetView;
        this.metaCreationTs = metaCreationTs;
        this.siteSurveys = siteSurveys;
        this.events = events;
        this.criticalWarning = criticalWarning;
    }
    FullJob.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new FullJob(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getSubobject(o, 'agency', agency_1.MinimalAgency.parse), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'assignments', Assignment.parse, 'throw'), cerealParse_1.ParseUtils.getStringOrNull(o, 'cadId'), o['centroid'], cerealParse_1.ParseUtils.getStringOrNull(o, 'crossStreets'), cerealParse_1.ParseUtils.getNumberOrNull(o, 'delayInSeconds'), cerealParse_1.ParseUtils.getEnum(o, 'disposition', JobDisposition), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'hydrants', hydrant_1.Hydrant.parse, 'throw'), cerealParse_1.ParseUtils.getStringOrNull(o, 'incidentId'), o['location'], cerealParse_1.ParseUtils.getStringOrNull(o, 'locationInfo'), cerealParse_1.ParseUtils.getString(o, 'locationOfIncident'), cerealParse_1.ParseUtils.getArray(o, 'rawIds'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'responders', Responder.parse, 'throw'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'supp', FullSupplemental.parse, 'throw'), cerealParse_1.ParseUtils.getString(o, 'synopsis'), cerealParse_1.ParseUtils.getUNIXTimestampDate(o, 'ts'), cerealParse_1.ParseUtils.getSubobject(o, 'type', JobType.parse), cerealParse_1.ParseUtils.getArray(o, 'units'), cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'streetView', StreetView.parse), cerealParse_1.ParseUtils.getUNIXTimestampDate(o, 'metaCreationTs'), cerealParse_1.ParseUtils.getArray(o, 'siteSurveys'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'events', JobEvent.parse, 'throw'), cerealParse_1.ParseUtils.getStringOrNull(o, 'criticalWarning')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid FullJob Model: " + e.message);
        }
    };
    return FullJob;
}());
exports.FullJob = FullJob;
var HeatmapParameters = /** @class */ (function () {
    function HeatmapParameters(weight, location, timestamp) {
    }
    HeatmapParameters.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new HeatmapParameters(cerealParse_1.ParseUtils.getNumber(o, 'weight'), o['location'], cerealParse_1.ParseUtils.getUNIXTimestampDate(o, 'timestamp')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid Heatmap Parameters Model: " + e.message);
        }
    };
    return HeatmapParameters;
}());
exports.HeatmapParameters = HeatmapParameters;
//# sourceMappingURL=job.js.map